<template>
    <div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import NotificationManager from '@/mixins/NotificationManager';
import VueRouter from 'vue-router';

const { isNavigationFailure, NavigationFailureType } = VueRouter;

export default {
  mixins: [NotificationManager],
  async mounted() {
    // Check if SSO is enabled or not
    const url = '/login/sso/properties';
    const response = await axios.get(url);

    const ssoProperties = response.data;
    const isSsoEnabled = ssoProperties.SSO_THIRD_PARTY;
    console.log(`Landing.mounted(): Check SSO enabled - isSsoEnabled=${isSsoEnabled}`);
    if (isSsoEnabled !== 'true') {
      this.$router.push({ name: 'notAuthorized' });
      return;
    }

    const params = new URLSearchParams();
    Object.keys(this.$route.query).forEach((key) => {
      if (key !== 'h') {
        params.append(key, this.$route.query[key]);
      }
    });

    // for (const p of params) {
    // console.log(`LoginSso.mounted(): loop Request-params, params=${params}`);
    // }

    const paramsFragment = this.getFragmentParameters();
    // const params = new URLSearchParams(paramsRequest.toString() + '&' + paramsFragment.toString());
    // console.log(`LoginSso.mounted():  fragment-params.toString()=${params.toString()}`);
    // for (const [key, value] of paramsFragment.entries()) {
    //   console.log('Parameter:', key);
    //   console.log('Value:', value);
    // }

    // add all fragment-parameters to params
    for (const [key, value] of paramsFragment.entries()) {
      params.append(key, value);
    }

    // for (const p of params) {
    //   console.log('LoginSso.mounted():  loop FINAL-params, p=' + p);
    // }

    const accessToken = this.getBearerTokenFromHeader();
    try {
      const user = await this.validateSsoLogin({
        params,
        accessToken,
      });
      console.log(`SSO-Message: SSO authentication completes, user.email=${user.email}`);

      /* Get properties and field-mappings */
      await Promise.all([
        this.initProperties(),
        this.initFields(),
      ]);

      this.hideNotification();

      // navigate to where we were trying to go
      // console.log(`SSO-Message: navigate to: query.r=${this.$route.query.r}`);
      // this.$router.push('/')
      this.$router.push(this.$route.query.r || '/')
        .catch((e) => {
          if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
            console.log('SSO-Message: $router.push() failed due to non-NavigationFailure.');
            Promise.reject(e);
          }
          // console.log('SSO-Message: error when redirect to home-page due to NavigationFailure, ok and continue redirecting...');
        });
    } catch (e) {
      // failed on authentication or >=1 promise failed, redirect user to SSO authentication portal
      console.log('SSO-Message: SSO authentication failed:', e.response.data);

      if (e.response.data.message === 'Authorization required') {
        const url2 = '/login/sso/redirecturl';
        const response2 = await axios.get(url2);
        const redirecturl = response2.data;
        window.location.href = redirecturl;
      } else if (e.response.data.message.startsWith('Authorization failed:')) {
        const url2 = '/login/sso/redirecturl';
        const response2 = await axios.get(url2);
        const redirecturl = new URL(response2.data);
        redirecturl.searchParams.set('response_type', 'failure');
        redirecturl.searchParams.set('message', e.response.data.message);
        window.location.href = redirecturl;
      } else {
        this.$router.push({ name: 'notAuthorized' });
      }
    }
  },
  methods: {
    ...mapActions({
      validateSsoLogin: 'validateSsoLogin',
      initProperties: 'propertiesModule/init',
      initFields: 'fieldLabelsModule/init',
    }),
    getBearerTokenFromHeader() {
      let encodedHeaderParam = null;
      let headers = {};
      Object.keys(this.$route.query).forEach((key) => {
        if (key === 'h') encodedHeaderParam = this.$route.query[key];
      });
      if (encodedHeaderParam != null) {
        const decodedHeaderParam = atob(encodedHeaderParam);
        headers = JSON.parse(decodedHeaderParam);
      }
      return headers.authorization;
    },
    getFragmentParameters() {
      const params = new URLSearchParams();
      let fragment = window.location.hash;

      console.log(`getFragmentParameters(): fragment=${fragment}`);

      // Remove the '#' symbol
      fragment = fragment.slice(1);
      const pairs = fragment.split('&');
      pairs.forEach((pair) => {
        const keyValue = pair.split('=');
        const key = keyValue[0];
        const value = keyValue[1];

        // Add the parameter and its value to the URLSearchParams object
        params.append(key, value);
      });

      console.log('getFragmentParameters(): params=', params.toString());

      return params;
    },
  },
};
</script>
